import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import { useLocation } from "react-router";

import styled from "styled-components";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useMediaQuery } from "@mui/material";
const SidebarItem = ({ item, isSidebarToggled, setShow = () => {} }) => {
  const [showSubmenu, setShowSubmenu] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  let pathname = location.pathname;
  const isMobile = useMediaQuery("(max-width: 768px)");

  // remove '/' from starting of link
  pathname = pathname.slice(1);
  useEffect(() => {
    if (String(pathname).split("/")[0] === item?.key) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [pathname]);

  return (
    <StyledWrapper className="align-items-center d-flex flex-column flex-lg-row ">
      <div className={open ? `sidebar-item open` : "sidebar-item"}>
        <Link
          to={item.link}
          className="link-hover"
          onClick={() => {
            setShowSubmenu(!showSubmenu);
            setOpen(!open);
          }}
        >
          <div
            className="align-items-center d-flex flex-row flex-lg-row py-2"
            style={{ paddingLeft: "5px" }}
          >
            <span className="mb-2  mb-lg-0 icon-wrapper">{item.icon}</span>
            <>
              {isSidebarToggled && (
                <>
                  <span
                    className="ms-lg-2 margin-3 body-15 name-wrapper text-wrap text-left  text-truncate"
                    style={{ fontSize: "12px", flexGrow: 1 }}
                  >
                    {item.name}
                  </span>
                  <span className="mb-2 mb-lg-0 icon-wrapper">
                    <KeyboardArrowDownIcon
                      // size={10}
                      className={open ? "rotated" : "unrotate"}
                      style={{
                        fontSize: "14px",
                        marginBottom: "-5px",
                        marginRight: "5px",
                      }}
                    />
                  </span>
                </>
              )}
            </>
            <>
              {isMobile && (
                <>
                  <span
                    className="ms-lg-2 margin-3 body-15 name-wrapper text-wrap text-left  text-truncate"
                    style={{ fontSize: "12px", flexGrow: 1 }}
                  >
                    {item.name}
                  </span>
                  <span className="mb-2 mb-lg-0 icon-wrapper">
                    <KeyboardArrowDownIcon
                      // size={10}
                      className={open ? "rotated" : "unrotate"}
                      style={{
                        fontSize: "14px",
                        marginBottom: "-5px",
                        marginRight: "5px",
                      }}
                    />
                  </span>
                </>
              )}
            </>
          </div>
        </Link>
        <div className="sidebar-content">
          {item.subMenu.map((sub, i) => (
            <Link to={sub.link} onClick={() => setShow(false)} key={i}>
              <SubMenuItem
                key={sub.key}
                item={sub}
                pathname={pathname}
                open={open}
                isSidebarToggled={isSidebarToggled}
                isMobile={isMobile}
              />
            </Link>
          ))}
        </div>
      </div>
    </StyledWrapper>
  );
};

const SubMenuItem = ({ item, pathname, open, isSidebarToggled, isMobile }) => {
  return (
    <>
      <li className={pathname.includes(item.link) && open ? "active" : ""}>
        <div
          className={
            pathname.includes(item.link) && open
              ? isMobile
                ? ""
                : "before"
              : ""
          }
        ></div>
        <StyledWrapper
          className={
            pathname.includes(item.link)
              ? "align-items-left d-flex flex-column flex-lg-row py-2 sub-item "
              : "align-items-left d-flex flex-column flex-lg-row py-2 sub-item"
          }
        >
          {isSidebarToggled && (
            <div>
              <span className="mb-2 mb-lg-0 icon-wrapper">{item.icon}</span>
              <span
                className="ms-lg-2 body-15  name-wrapper text-wrap text-center  text-truncate"
                style={{ fontSize: "12px" }}
              >
                {item.name}
              </span>
            </div>
          )}
          {isMobile && (
            <div>
              <span className="mb-2 mb-lg-0 icon-wrapper">{item.icon}</span>
              <span
                className="ms-lg-2 body-15  name-wrapper text-wrap text-center  text-truncate"
                style={{ fontSize: "12px" }}
              >
                {item.name}
              </span>
            </div>
          )}
        </StyledWrapper>
        <div
          className={
            pathname.includes(item.link) && open
              ? isMobile
                ? ""
                : "after"
              : ""
          }
        ></div>
      </li>
    </>
  );
};

export default SidebarItem;

const StyledWrapper = styled.div`
  .margin-3 {
    margin-left: 10px;
    margin-top: 5px;
  }
  .icon-wrapper {
    svg {
      height: 18px;
      width: 18px;
    }
  }
  .sidebar-item {
    margin: 0;
  }
  .sidebar-content {
    padding-top: 0.25rem;
    height: 0;
    transition: 0.4s;
  }

  .rotated {
    transform: rotate(0deg);
    transition: 0.5s;
  }
  .unrotate {
    transition: 0.5s;
    transform: rotate(-90deg);
  }

  .sub-item:hover {
    color: black;
    background: white;
  }
  .sub-item {
    padding-left: 2.5rem;
    padding-right: 0;
    width: 201px;
  }

  .sidebar-item.open .sidebar-content {
    padding-top: 0.5rem;
    padding-bottom: 1.5rem;
    height: auto;
  }

  .before {
    position: absolute;
    margin-top: -20px;
    right: 0px;
    width: 20px;
    height: 20px;
    background: transparent;
    border-radius: 50%;
    box-shadow: 10px 10px 0 white;
    transition: 0.5s;
  }

  .after {
    position: absolute;
    right: 0px;
    width: 20px;
    height: 20px;
    background: transparent;
    border-radius: 50%;
    box-shadow: 10px -10px 0 white;
    transition: 0.5s;
  }
  .active {
    border-radius: 10px;
    background: white;
    transition: 0.5s;
  }

  .active span {
    color: black;
  }
`;
